module.exports = __webpack_public_path__ + "static/media/final-r-en.03d9796f.png";